import { FetchLookupsResponse } from '@lib/api';

import { LookupsValue } from '../types';

export function getBranchesAddressFromLookupsResponse(
  lookupsResponse: FetchLookupsResponse,
): LookupsValue['branchesAddress'] {
  const branches = lookupsResponse.branchesAddress.map((branch) => {
    return {
      zone: {
        arName: branch.zoneNameAr,
        enName: branch.zoneNameEn,
      },
      area: {
        arName: branch.areaNameAr,
        enName: branch.areaNameEn,
      },
      city: {
        arName: branch.cityNameAr,
        enName: branch.cityNameEn,
      },
      branchAddress: {
        arName: branch.branchAddressAr,
        enName: branch.branchAddressEn,
      },
      restaurantName: {
        arName: branch.restaurantNameAr,
        enName: branch.restaurantNameEn,
      },
      branchUUID: branch.branchUUID,
    };
  });

  return branches;
}
